import "./asnGRNViewDetails.css";
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
// import { authKey, getLocalStorageItem('id_token')} from '../../common/URLs';

import jwt from "jwt-decode";
//import { ConfirmPopover } from '../preregcamps/confirmPopover/confirmPopover';
// import { ErrorPopover } from '../../common/ErrorPopover/errorPopover';
import { confirmAlert } from 'react-confirm-alert';
// import { loaderService } from "../../common/custom-loader/loader-service";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Table } from "react-bootstrap";
// import TrashIcon from "../../images/TrashIcon.png";
// import { CommonRegistrationSidebar } from "../../common/common-registration-sidebar/commonRegistrationSidebar";
import { UnloadingDetailsPopover } from "./unloadingDetailsPopover";
import { OdoMeterPopover } from './odoMeterPopover';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { useLocation } from 'react-router-dom';
import { authKey, ISSUE_GRN_INVOICE, UPDATE_PLANT_UNLOADING_DATA, TOLERANCE, GET_CONSIGNMENT_DETAILS_BY_NUMBER, GET_USER_DETAILS, GET_CONFIGURATION_VALUES } from '../../../common/URLs';
import { loaderService } from "../../../common/custom-loader/loader-service";
import Moment from 'moment';
import { PROD } from "../../../common/constants";
import { } from "../../../common/commonValidations";
import { ContactlessOutlined } from "@mui/icons-material";
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import apiClient from "../../../axios";

function ChippingAsnGrnViewDetails() {
  const navigate = useNavigate();
  const decoded = jwt(getLocalStorageItem('id_token'));
  const consignmentData = useLocation().state.selectedRow;
  const [accountName, setAccountName] = useState();
  const [urn, setUrn] = useState();
  const [consignmentDetails, setConsignmentDetails] = useState({
    "destinationGrossWeight": "",
    "destinationTareWeight": "",
    "destinationNetWeight": "",
    "destinationTotalMoisture": "",
    "deviationWeight": "",
    "deviationWeightPer": "",
    "deviationMoisture": "",
    "deviationMoisturePer": "",
    "destinationComments": "",

  });
  const [deliveryMeasurements, setDeliveryMeasurements] = useState({});
  const [consignmentLotDetails, setConsignmentLotDetails] = useState({});
  const [configLimit, setConfigLimit] = React.useState(2);
  const [configLimitWeight, setConfigLimitWeight] = React.useState(0);
  const [configLimitMoisture, setConfigLimitMoisture] = React.useState(0);
  const [getTolerance, setGetTolerance] = useState([]);

  const [sourceDetails, setSourceDetails] = useState([]);
  const [grnIssue, setGrnIssue] = useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);

  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);

  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const handleLogModalClose2 = () => setLogModalOpen2(false);

  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleLogModalClose4 = () => setLogModalOpen4(false);

  const [unloadingDataSave, setUnloadingDataSave] = useState();
  useEffect(() => {
    // console.log(scheduleItem);
    toleranceLimit();
    getViewDetails();
  }, []);

  useEffect(() => {
    getUserDetails();
  }, []);

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setAccountName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname)
      })
      .catch(function (error) {
        console.log(error);
      });
  }

const toleranceLimit = () => {
    loaderService.showLoader();
    apiClient
        .post(
            GET_CONFIGURATION_VALUES,
            {
              "serviceType": "QualityToleranceLimit"
            },
            {
                headers: {
                    Authorization: "Bearer " + getLocalStorageItem('id_token'),
                },
            }
        )
        .then((response) => {
            const configList = response?.data?.configurationDetailList || [];
            setGetTolerance(configList);

            configList.forEach((tl) => {
                const appKey = tl.appKey?.toLowerCase();
                if (appKey === "weight") {
                    setConfigLimitWeight(Number(tl.value) || 0);
                }
                if (appKey === "moisture") {
                    setConfigLimitMoisture(Number(tl.value) || 0);
                }
            });

            loaderService.hideLoader();
        })
        .catch(function (error) {
            console.log("apiClientERROR", error);
            loaderService.hideLoader();
            toast.error(error.message);
        });
};


  const handleChange = (e) => {
    setConsignmentDetails({ ...consignmentDetails, [e.target.name]: e.target.value });
  }

  // const handleChange = (e) => {
  //     let totalLotWeight = consignmentLotDetails?.inventoryList.reduce((total, e) => Number(e.pickupWeight) + total, 0);
  //     let avgMoisture = (consignmentLotDetails?.inventoryList.reduce((total, e) => Number(e.pickupMoisture) + total, 0))/consignmentLotDetails?.inventoryList.length;
  //     console.log("cb",consignmentLotDetails);

  //     if (e.target.name === "destinationTareWeight" ) {

  //         deliveryMeasurements.destinationNetWeight = deliveryMeasurements.destinationGrossWeight - e.target.value;
  //         deliveryMeasurements.deviationWeight = Math.round((((deliveryMeasurements.destinationNetWeight-totalLotWeight)/totalLotWeight)*100)*100)/100;
  //         deliveryMeasurements.deviationMoisture =  Math.round((((deliveryMeasurements.destinationMoisture-avgMoisture)/consignmentData.totalMoisture)*100)*100)/100;
  //     }

  //     if (e.target.name === "destinationGrossWeight") {
  //         deliveryMeasurements.destinationNetWeight = e.target.value- deliveryMeasurements.destinationTareWeight
  //         deliveryMeasurements.deviationWeight =  Math.round((((deliveryMeasurements.destinationNetWeight-totalLotWeight)/totalLotWeight)*100)*100)/100;
  //         deliveryMeasurements.deviationMoisture =  Math.round((((deliveryMeasurements.destinationMoisture-avgMoisture)/consignmentData.totalMoisture)*100)*100)/100;
  //     }

  //     if (e.target.name === "destinationMoisture") {
  //         console.log("destination moisture");
  //         //deliveryMeasurements.destinationNetWeight = e.target.value- deliveryMeasurements.destinationTareWeight
  //         //deliveryMeasurements.deviationWeight =  deliveryMeasurements.destinationNetWeight-consignmentData.consignmentWeight;
  //         deliveryMeasurements.deviationMoisture =  Math.round((((e.target.value-avgMoisture)/consignmentData.totalMoisture)*100)*100)/100;
  //     }
  //     let weightDeviation = deliveryMeasurements.destinationNetWeight-totalLotWeight;
  //     let lotsList=consignmentLotDetails?.inventoryList
  //     let splitVal = 0;
  //     if(deliveryMeasurements.deviationWeight  && (deliveryMeasurements.deviationWeight > configLimit || deliveryMeasurements.deviationWeight < -configLimit)){
  //         if(deliveryMeasurements.deviationWeight!=null && lotsList?.length>0){
  //             splitVal = Math.round((weightDeviation/lotsList?.length)*100)/100;
  //         }
  //         lotsList?.forEach(lot=>{
  //           lot.isRestrictedInventory =true
  //           lot.isUnrestrictedInventory =false;
  //           lot.arrivalWeight=lot.pickupWeight + splitVal
  //        })
  //     }else if( deliveryMeasurements.deviationWeight  && (deliveryMeasurements.deviationWeight <= configLimit || deliveryMeasurements.deviationWeight >= -configLimit)){
  //         if(deliveryMeasurements.deviationWeight!=null && lotsList?.length>0){
  //             splitVal = Math.round((weightDeviation/lotsList?.length)*100)/100;
  //         }
  //         lotsList?.forEach(lot=>{
  //             lot.isRestrictedInventory =false
  //             lot.isUnrestrictedInventory =true;
  //             lot.arrivalWeight=lot.pickupWeight + splitVal
  //          })
  //     }

  //     if(deliveryMeasurements.deviationMoisture  && (deliveryMeasurements.deviationMoisture > configLimit || deliveryMeasurements.deviationMoisture < -configLimit)){
  //         if(deliveryMeasurements.deviationMoisture!=null && lotsList?.length>0){
  //             splitVal = Math.round((deliveryMeasurements.deviationMoisture/lotsList?.length)*100)/100;
  //         }
  //         lotsList?.forEach(lot=>{

  //           lot.arrivalMoisture=lot.pickupMoisture
  //        })
  //     }else if( deliveryMeasurements.deviationMoisture  && (deliveryMeasurements.deviationMoisture <= configLimit || deliveryMeasurements.deviationMoisture >= -configLimit)){
  //         if(deliveryMeasurements.deviationMoisture!=null && lotsList?.length>0){
  //             splitVal = Math.round((deliveryMeasurements.deviationMoisture/lotsList?.length)*100)/100;
  //         }
  //         lotsList?.forEach(lot=>{
  //            // lot.isRestrictedInventory =false

  //            // lot.isUnrestrictedInventory =true;
  //             lot.arrivalMoisture=lot.pickupMoisture
  //          })
  //     }

  //     setConsignmentLotDetails(consignmentLotDetails);
  //     console.log(deliveryMeasurements.deviationMoisture);
  //     if(e.target.name==="destinationComments"){
  //         setDeliveryMeasurements({ ...deliveryMeasurements, [e.target.name]: e.target.value});
  //         return
  //     }
  //     setDeliveryMeasurements({ ...deliveryMeasurements, [e.target.name]: Number(e.target.value) });
  // }

  // const [showGrid, setShowGrid] = useState(false);
  // const [hideClickHere, setHideClickHere] = useState(true);
  // const [yesVisible, setYesVisible] = useState("");
  // const [noVisible, setNoVisible] = useState("");

  // const handleShowGrid = (e) => {
  //   e.preventDefault();
  //   if (e.target.value === "yes") {
  //     setYesVisible(true);
  //     setNoVisible(false);
  //   } else {
  //     setYesVisible(false);
  //     setNoVisible(true);
  //   }
  // };
  const getViewDetails = () => {
    let data = {
      "consignmentNumber": consignmentData?.consignmentNo,
    };
    let headers = {
      Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    }
    apiClient
      .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER, data, { headers })
      .then(res => setConsignmentDetails(res.data),
        res => setSourceDetails(res.data.consignmentSourceDetails))
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  };
  const rbcbDetails = consignmentDetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs;



  const onClickEdit = (e) => {

    confirmAlert({

      customUI: ({ onClose }) => {

        return (

          <UnloadingDetailsPopover onClose={onClose} />

        );

      }

    });
  }

  const onProceed = (e) => {
    navigate('/asnProceed', {
      state: consignmentDetails
    })
  }

  const onClickEndTrip = (onClose) => {
    handleLogModalOpen4(onClose);

    // confirmAlert({

    //     customUI: ({ onClose }) => {

    //         return (

    //             <OdoMeterPopover consignmentNumber={consignmentDetails.consignmentNo} onClose={onClose} />


    //         );

    //     }

    // });
  }

  // const saveDeliveryMeasurements = (unloadingDone) => {
  //     console.log(deliveryMeasurements);

  //     let lotList = [];
  //     // !unloadingDone && consignmentLotDetails.inventoryList.forEach(lot => {
  //     //     lotList.push({

  //     //         "consignmentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  //     //         "bundleId": lot.bundleId,
  //     //         "arrivalWeight": lot.arrivalWeight,
  //     //         "arrivalMoisture": lot.arrivalMoisture,
  //     //         "isRestrictedInventory": lot.isRestrictedInventory,
  //     //         "isUnrestrictedInventory": lot.isUnrestrictedInventory,
  //     //         "isScrapInventory": lot.isScrapInventory






  //     //         // "inventoryId": lot.id,
  //     //         // "materialType": lot.materialType,
  //     //         // "lotId": lot.id,
  //     //         // "bundleId": lot.bundleId,
  //     //         // "isRestrictedInventory": lot.isRestrictedInventory,
  //     //         // "isUnrestrictedInventory": lot.isUnrestrictedInventory,
  //     //         // "isScrapInventory": lot.isScrapInventory,
  //     //         // "totalQuantity": lot.arrivalWeight,
  //     //         // "totalMoisture":lot.arrivalMoisture,
  //     //         // "unrestrictedWithoutDeviation": 0,
  //     //         // "unrestrictedWeight": lot.isUnrestrictedInventory ? lot.arrivalWeight : 0,
  //     //         // "unrestrictedMoisture": lot.isUnrestrictedInventory ? lot.arrivalMoisture : 0,
  //     //         // "restrictedWithoutDeviation": 0,
  //     //         // "restrictedWeight":lot.isRestrictedInventory ? lot.arrivalWeight : 0,
  //     //         // "restrictedMoisture":lot.isRestrictedInventory ? lot.arrivalMoisture : 0, 
  //     //         // "scrap": 0,
  //     //         // "scrapWeight": lot.isScrapInventory ? lot.arrivalWeight : 0,
  //     //         // "scrapMoisture":lot.isScrapInventory ? lot.arrivalMoisture : 0,
  //     //         // "categorizationLead1": "",
  //     //         // "categorizationLead2": ""

  //     //     })
  //     // })
  //     let requestData = {

  //         ...deliveryMeasurements,
  //         "isInPermissibleLimit": true,
  //         "isUnloadingDone": unloadingDone,
  //         "deviationWeightPer": deliveryMeasurements.deviationWeight,
  //         "deviationMoisturePer": deliveryMeasurements.deviationMoisture,
  //         "consignmentId": consignmentData.id,

  //         "consignmentNo": consignmentData.consignmentNo,
  //         "lstCategorization":lotList
  //     }
  //     console.log(requestData)

  //     let headers = {
  //         Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
  //     }
  //     apiClient
  //         .post("https://abeplscm-dev.abepl.co.in/pit/v1/RawBambooArrival/update_unloading_data", requestData, { headers })
  //         .then(res => {

  //             confirmAlert({
  //                 customUI: ({ onClose }) => {
  //                     return (
  //                         <ConfirmPopover onClose={onClose} title={res.data.message} hideLink={true} />
  //                     );
  //                 }
  //             });

  //         })
  //         .catch(err => {

  //         });
  // }

  const saveDeliveryMeasurements = (e, unloadingDone) => {
    unloadingsave(unloadingDone);
  }

  const unloadingsave = (unloadingDone) => {

    // let totalLotWeight = consignmentLotDetails?.inventoryList.reduce((total, e) => Number(e.pickupWeight) + total, 0);
    //  let avgMoisture = (consignmentLotDetails?.inventoryList.reduce((total, e) => Number(e.pickupMoisture) + total, 0))/consignmentLotDetails?.inventoryList.length;
    loaderService.showLoader()
    apiClient
      .post(UPDATE_PLANT_UNLOADING_DATA,
        {
          "consignmentId": consignmentData.consignmentId,
          "consignmentNo": consignmentData.consignmentNo,
          "tokenNo": null,
          "destinationGrossWeight": consignmentDetails.destinationGrossWeight,
          "destinationTareWeight": consignmentDetails.destinationTareWeight,
          "destinationNetWeight": (consignmentDetails.destinationGrossWeight) - consignmentDetails?.destinationTareWeight,
          "destinationMoisture": consignmentDetails.destinationTotalMoisture,
          "deviationWeight": null,
          "deviationWeightPer": ((((consignmentDetails.pickupNetWeight) - ((consignmentDetails.destinationGrossWeight) - consignmentDetails?.destinationTareWeight)) / consignmentDetails.pickupNetWeight) * 100).toFixed(2),
          "deviationMoisture": null,
          "deviationMoisturePer": ((((consignmentDetails.totalMoisture) - (consignmentDetails?.destinationTotalMoisture)) / consignmentDetails.totalMoisture) * 100).toFixed(2),
          "isInPermissibleLimit": true,
          "isUnloadingDone": unloadingDone,
          "actualDeviationWeightPercent": configLimitWeight,
          "actualDeviationMoisturePercent": configLimitMoisture,
          "destinationComments": consignmentDetails.destinationComments,
          "arrivalWeight": consignmentDetails.pickupNetWeight,
          "arrivalMoisture": consignmentDetails.totalMoisture
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        // setLotDetailsArrNew([]);
        setUnloadingDataSave(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        setUnloadingDataSave(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  // console.log("popup",unloadingDataSave?.message);

  useEffect(() => {
    if (unloadingDataSave) {
      if (unloadingDataSave?.isSuccess === true) {

        handleLogModalOpen1();
      }
      else {

        handleLogModalOpen();
      }
    }
  }, [unloadingDataSave]);

 
  const issueInvoice = (e) => {
    issueGrnInvoice();
  }

  const issueGrnInvoice = () => {
    loaderService.showLoader()
    apiClient
      .post(ISSUE_GRN_INVOICE,
        {
          "consignmentNo": consignmentData?.consignmentNo,
          "roleName" : decoded.extension_URN ? "stakeholder" : localStorage.getItem('role'),
          "userName": decoded.extension_URN ? decoded.extension_URN : accountName
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        // console.log("1",response);
        setGrnIssue(response.data);
        loaderService.hideLoader();
        // setHideButtons(response.data.consignmentSourceDetails[0].invoiceNo!=null);
        // setTotalGrower(response.data.consignmentSourceDetails);
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }


  useEffect((e) => {
    //  e.preventDefault();
    if (grnIssue) {
      if (grnIssue.isSuccess === true) {

        handleLogModalOpen2();
      }
      else {

        handleLogModalOpen();
      }
    }
  }, [grnIssue]);

  return (
    <div>
      <Container fluid>
        <Row>
          <Col xs={12} md={12}>
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT15</p>}
            <div>
              <form>
                <div>
                  <Container fluid>
                    <p className='headingStylePIT'>Consignment Details</p>
                    <Row>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Consignment #</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentNo} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Consignment Owner URN#</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentSourceUrn} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Consignment Owner Name</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentOwnerName} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Consignment Owner Contact</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentOwnerContactNo} type="number" onFocus={handleNumberFieldFocus} name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Date & Time of loading completion</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.loadingCompleteDate && Moment(consignmentDetails.loadingCompleteDate).format('DD/MM/YYYY')} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Pick-up Location URN#</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails?.consignmentSourceDetails?.[0]?.sourceStakeholderUrn} type="text" name="" disabled={true}></input>
                        {/* <p className='asn-grn-labels'>Total weight picked up</p>     
                                  <input className='asn-grn-input-disabled' type="number"  name="" disabled={true} ></input> */}
                      </Col>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Pick-up Location Name</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails?.consignmentSourceDetails?.[0]?.sourceLocationName} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Pick-Up Location Address</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails?.consignmentSourceDetails?.[0]?.sourceLocationAddress} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Average Moisture during the pickup</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.totalMoisture} type="number" onFocus={handleNumberFieldFocus} name="" disabled={true} ></input>
                        <p className='asn-grn-labels'>Scheduled Delivery date</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.scheduleDeliveryTimestamp && Moment(consignmentDetails.scheduleDeliveryTimestamp).format('DD/MM/YYYY')} type="text" name="" disabled={true}></input>
                        {/* <p className='asn-grn-labels'>Pick-up Location URN#</p>     
                                  <input className='asn-grn-input-disabled' type="text"  name="" disabled={true}></input>
                                  <p className='asn-grn-labels'>Pick-up Location Name</p>     
                                  <input className='asn-grn-input-disabled' type="text" name="" disabled={true}></input>
                                  <p className='asn-grn-labels'>Pick-Up Location Address</p>     
                                  <input className='asn-grn-input-disabled' type="text"  name="" disabled={true}></input> */}
                        <p className='asn-grn-labels'>Driver License number</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.driverLicenseNo} type="text" disabled={true}></input>
                        <p className='asn-grn-labels'>Driver Contact</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.driverContact} type="number" onFocus={handleNumberFieldFocus} name="" disabled={true}></input>


                      </Col>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Delivery Location URN#</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentDestinationStakeholderUrn} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Delivery Location Name</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentDestinationLocationName} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Delivery Location Address</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.consignmentDestinationLocationAddress} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Vehicle Registration</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.vehicleRegNo} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Driver Name</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.driverName} type="text" name="" disabled={true}></input>
                        <p className='asn-grn-labels'>Material Type</p>
                        <input className='asn-grn-input-disabled' value={consignmentDetails.materialType} type="text" name="" disabled={true}></input>
                        {/* <p className='asn-grn-labels'>Total weight (in kg)picked up</p>
                                                <input className='asn-grn-input-disabled' value={consignmentDetails.totalWeight }  type="number" name="" disabled={true} ></input> */}
                        {/* <p className='asn-grn-labels'>Driver ID</p>     
                                  <input className='asn-grn-input-disabled' type="text"  disabled={true}></input>
                                  <p className='asn-grn-labels'>Driver Contact</p>     
                                  <input className='asn-grn-input-disabled' type="number"  name="" disabled={true}></input> */}
                      </Col>

                      {/* <Col xs={12} md={2}>    
                          <div className='submit-div-bamboo-supply'>
                          <button className='submit-btn-bamboo-supply' type='submit'>Submit</button>
                          </div>                                                               
                          </Col>                                                 */}
                    </Row>
                  </Container>
                  <Container fluid>
                    <Row>
                      <p className="asn-grn-heading1">Weighbridge Measurement at Pick Up Location</p>
                      <Col xs={12} md={4}>
                        <div className="asn-grn-labels">Tare weight measured @ LLE<span className='mandatory_field'>*</span></div>
                        <input className='asn-grn-input-disabled' type="number" onFocus={handleNumberFieldFocus} name="pickupTareWeight" value={consignmentDetails.pickupTareWeight} disabled={true} />
                        {/* <div className="error-msg">
                                                {errorMessage.pickupTareWeightError}
                                                </div> */}
                        <div className="asn-grn-labels">Average Moisture during the pickup<span className='mandatory_field'>*</span></div>
                        <input className='asn-grn-input-disabled' type="number" onFocus={handleNumberFieldFocus} name="totalMoisture" value={consignmentDetails.totalMoisture} disabled={true} />
                      </Col>
                      <Col xs={12} md={4}>
                        <div className="asn-grn-labels">Average Chip Size<span className='mandatory_field'>*</span></div>
                        <input className='asn-grn-input-disabled' type="number" onFocus={handleNumberFieldFocus} name="pickupAvgChipSize" value={consignmentDetails.pickupAvgChipSize} disabled={true} />
                        <div className="asn-grn-labels"> Gross weight measured @ LLE<span className='mandatory_field'>*</span> </div>
                        <input className='asn-grn-input-disabled' type="number" onFocus={handleNumberFieldFocus} name="pickupGrossWeight" value={consignmentDetails.pickupGrossWeight} disabled={true} />
                      </Col>
                      <Col xs={12} md={4}>
                        <div className="asn-grn-labels">Weight during pickup<span className='mandatory_field'>*</span></div>
                        <input className='asn-grn-input-disabled' type="number" onFocus={handleNumberFieldFocus} name="pickupNetWeight" value={consignmentDetails.pickupNetWeight} disabled={true} />
                      </Col>

                    </Row>
                  </Container>
                  <Container fluid>
                    <Row>
                      <p className="asn-grn-heading1">Weighbridge Measurement at Delivery Location</p>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Gross weight (in MT) measured</p>
                        <input className='asn-grn-input' value={consignmentDetails.destinationGrossWeight} type="number" onFocus={handleNumberFieldFocus} placeholder='Gross weight measured' name="destinationGrossWeight" onChange={(e) => handleChange(e)} ></input>
                        <p className='asn-grn-labels'>Tare weight (in MT) measured</p>
                        <input className='asn-grn-input' value={consignmentDetails.destinationTareWeight} type="number" onFocus={handleNumberFieldFocus} placeholder='Tare weight measured' name="destinationTareWeight" onChange={(e) => handleChange(e)} ></input>
                      </Col>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Net weight(in MT) as per measurement</p>
                        <input className='asn-grn-input' value={(consignmentDetails.destinationGrossWeight) - consignmentDetails?.destinationTareWeight} disabled type="number" onFocus={handleNumberFieldFocus} placeholder='Net weight as per measurement' name="destinationNetWeight" onChange={(e) => handleChange(e)}></input>
                        <p className='asn-grn-labels'>Average Moisture</p>
                        <input className='asn-grn-input' value={consignmentDetails.destinationTotalMoisture} type="number" onFocus={handleNumberFieldFocus} placeholder='Average Moisture' name="destinationTotalMoisture" onChange={(e) => handleChange(e)}></input>
                      </Col>
                      <Col xs={12} md={4}>
                        <p className='asn-grn-labels'>Deviation Weight(in %)</p>
                        <input className='asn-grn-input' value={((((consignmentDetails.pickupNetWeight) - ((consignmentDetails.destinationGrossWeight) - consignmentDetails?.destinationTareWeight)) / consignmentDetails.pickupNetWeight) * 100).toFixed(2)} disabled type="number" name="deviationWeight" onChange={(e) => handleChange(e)}></input>
                        <p className='asn-grn-labels'>Deviation Moisture(in %)</p>
                        <input className='asn-grn-input' value={((((consignmentDetails.totalMoisture) - (consignmentDetails?.destinationTotalMoisture)) / consignmentDetails.totalMoisture) * 100).toFixed(2)} disabled type="number" name="deviationMoisturePer" onChange={(e) => handleChange(e)}></input>
                      </Col>
                      <Container fluid>
                        <Col xs={12} md={8}>
                          <p className="asn-grn-heading1">Heap Details</p>
                          <div className='common-table-div' style={{ marginTop: "2vh" }}>
                            <Table responsive className="common-table" striped>
                              <thead>
                                <tr>
                                  <th className='common-table-heading-text'>Heap No#</th>
                                  <th className='common-table-heading-text'>Pick Up Weight</th>
                                  <th className='common-table-heading-text'>Pick Up Moisture</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rbcbDetails && rbcbDetails.map(heap =>
                                  <tr>
                                    <td className='common-table-text'>{heap.bundleId}</td>
                                    <td className='common-table-text'>{heap.rbCbWeight}</td>
                                    <td className='common-table-text'>{heap.avgMoisture}</td>
                                  </tr>
                                )}

                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Container>
                      <Row>
                        <Col xs={12} md={8}>
                          <div>
                            <p className='asn-grn-labels'>Comments</p>
                            <textarea style={{ height: "100px", width: "86%" }} value={consignmentDetails.destinationComments} className='asn-grn-input' placeholder='comments' name="destinationComments" onChange={(e) => handleChange(e)}></textarea>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </Container>
                  <Container fluid>
                    <Row>
                      <Col xs={12} md={3}>
                        {consignmentDetails?.consignmentDeliveryTimestamp != null &&
                          consignmentDetails.consignmentStatus == "GRNCompleted" ||
                          consignmentDetails.consignmentStatus == "UnloadingCompleted" ? null :
                          <div className='submit-div-asn-grn'>
                            <button className='submit-btn-asn-grn-save-cb' onClick={onClickEndTrip}>End Trip</button>
                          </div>
                        }
                      </Col>
                      <Col xs={12} md={2}>
                        {consignmentDetails?.consignmentDeliveryTimestamp == null &&
                          <div className='submit-div-asn-grn'>
                            <button className='submit-btn-asn-grn-save-cb' onClick={(e) => saveDeliveryMeasurements(e, false)}>Save</button>
                          </div>
                        }
                      </Col>
                      <Col xs={12} md={2}>
                        {consignmentDetails?.consignmentDeliveryTimestamp != null &&
                          consignmentDetails.consignmentStatus == "GRNCompleted" ||
                          consignmentDetails.consignmentStatus == "UnloadingCompleted" ? null :
                          <div className='submit-div-asn-grn'>
                            <button className='submit-btn-asn-grn-save-cb' onClick={(e) => saveDeliveryMeasurements(e, true)} type='submit'>Complete Unloading</button>
                          </div>
                        }
                      </Col>
                      <Col xs={12} md={2}>
                        {consignmentDetails?.consignmentDeliveryTimestamp != null &&
                          consignmentDetails.consignmentStatus == "GRNCompleted" ? null :
                          <div className='submit-div-asn-grn'>
                            <button className='submit-btn-asn-grn-save-cb' onClick={(e) => issueInvoice(e)} type='submit'>Create GRN</button>
                          </div>
                        }
                      </Col>

                      {/* <Col xs={12} md={12}>
                                            <button className='nextBtn_consignment_complete' onClick={onClickEndTrip}>End Trip</button>
                                    </Col> */}
                    </Row>
                  </Container>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
      <Dialog maxWidth='md' fullWidth open={logModalOpen4}>
        <DialogContent>
          <OdoMeterPopover consignmentNumber={consignmentDetails.consignmentNo} handleLogModalClose={handleLogModalClose4} />
          {/* <OdoMeterPopover tripEnded={tripEnded} consignmentNumber={consignmentDetails.consignmentNo} handleLogModalClose={handleLogModalClose4} /> */}
        </DialogContent>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={"ERROR"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={unloadingDataSave?.message ? unloadingDataSave?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={grnIssue?.message} hideLink={true}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose}>OK</Button>
        </DialogActions>
      </Dialog> */}
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={grnIssue?.message ? grnIssue?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );



}
export default ChippingAsnGrnViewDetails;
